import React, { Component, Fragment } from 'react'
import { I18n } from 'react-i18next'
import i18next from 'i18next'
import { BrowserRouter, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import Navigation from './Components/Navigation'
import Home from './Containers/Home'
import './App.css'

class App extends Component {
  getContentFromCMS(lang) {
    let page, description, title
    const CMSURL = 'https://cms.bizonprefab.nl/wp-json/wp/v2/pages'

    if (lang === 'en') {
      page = '52'
      description = 'Your dream home at a fraction of the cost. BIZON Prefab assists you in compiling the prefab house as desired.'
      title = 'BIZON Prefab – Prefab houses'
    } else if (lang === 'de') {
      page = '55'
      description = 'Ihr Traumhaus für einen bruchteil des preises. BIZON Prefab unterstützt Sie bei der Zusammenstellung Ihres Fertighaus.'
      title = 'BIZON Prefab – Fertighaus'
    } else {
      page = '19'
      description = 'Jouw droomhuis voor een fractie van de prijs. BIZON Prefab helpt je bij het samenstellen van een prefab huis naar wens.'
      title = 'Bizon Prefab – Prefab huizen'
    }

    this.setState({
      description, title
    })

    fetch(`${CMSURL}/${page}`)
      .then((res) => res.json())
      .then((response) => {
        this.setState({
          content: response
        })
      })
  }

  componentWillMount() {
    const timeOut = setTimeout(() => {
      if (i18next.isInitialized) {
        this.getContentFromCMS(i18next.language)
        clearTimeout(timeOut)
      }
    }, 100)
  }

  render() {
    return (
      <I18n ns="translations">
      {(t, { i18n }) => (
        <BrowserRouter>
          <Fragment>
            {this.state && this.state.hasOwnProperty('description') && this.state.hasOwnProperty('title') &&
              <Helmet>
                <meta charSet="utf-8" />
                <html lang={i18next.language} />
                <title>{this.state.title}</title>
                <meta name="description" content={this.state.description} />
                <link rel="canonical" href="https://bizonprefab.nl" />
                <meta name="geo.position" content="50.7733965; 6.0134136" />
                <meta name="geo.placename" content="Vaals" />
                <meta name="geo.region" content="nl" />
              </Helmet>
            }
            <Navigation getContentFromCMS={(lang) => this.getContentFromCMS(lang)} />
              {this.state && this.state.hasOwnProperty('content') &&
                <main>
                  <Route exact path="/" render={() => <Home content={this.state.content} />} />
                  <Route path="/:locale" render={() => <Home content={this.state.content} />} />
                </main>
              }
          </Fragment>
        </BrowserRouter>
      )}
      </I18n>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js